/*!
 * Katt Cosmic - cinematic scroll-controlled background (Galaxy \u2192 Geode \u2192 Smoke)
 * One fixed canvas behind the page. The scroll POSITION picks the exact frame of
 * the Galaxy\u2192Geode and Geode\u2192Smoke transformations, forwards and backwards.
 * No dependencies. Works in the Shopify theme editor.
 */
(function () {
  'use strict';
  if (window.KattCosmic) return;

  /* ---------------------------------------------------------------- helpers */
  var clamp = function (v, a, b) { a = a == null ? 0 : a; b = b == null ? 1 : b; return v < a ? a : v > b ? b : v; };
  var smoothstep = function (a, b, x) {
    if (b <= a) return x >= b ? 1 : 0;
    var t = clamp((x - a) / (b - a));
    return t * t * (3 - 2 * t);
  };
  var pad3 = function (n) { n = String(n); while (n.length < 3) n = '0' + n; return n; };
  var mq = function (q) { return !!(window.matchMedia && window.matchMedia(q).matches); };
  var idle = function (cb) {
    return 'requestIdleCallback' in window ? window.requestIdleCallback(cb, { timeout: 1500 }) : setTimeout(cb, 250);
  };
  var absUrl = function (u) { return u && u.indexOf('//') === 0 ? location.protocol + u : u; };
  var WIDTHS = [480, 640, 750, 960, 1080, 1280, 1440, 1600, 1920, 2400];

  /* "//shop/cdn/shop/files/kc-galaxy-geode-001.jpg?v=123" \u2192 { base, ext } */
  function parseTemplate(url) {
    if (!url) return null;
    var m = String(url).match(/^(.*?)001(\.[a-z0-9]+)(?:\?.*)?$/i);
    if (!m) return null;
    return { base: absUrl(m[1]), ext: m[2] };
  }

  function pickSource(list, preferH) {
    if (!list || !list.length) return null;
    var mp4 = list.filter(function (s) { return s && s.url; }).sort(function (a, b) { return (a.h || 0) - (b.h || 0); });
    if (!mp4.length) return null;
    var pick = mp4[0];
    for (var i = 0; i < mp4.length; i++) if ((mp4[i].h || 0) <= preferH) pick = mp4[i];
    return absUrl(pick.url);
  }

  /* ---------------------------------------------------------- FrameSequence
     Image frames exported from the Kling video. Loaded progressively:
     first + last frame, then every 32nd, 16th ... so scrubbing works early
     and gets finer as more frames arrive. */
  function FrameSequence(o) {
    this.tpl = o.tpl;
    this.width = o.width;
    this.onLoad = o.onLoad;
    this.max = o.concurrency || 6;
    var frames = [];
    if (o.only) frames = o.only.slice();
    else {
      var count = Math.max(2, o.count | 0), step = Math.max(1, o.step | 0);
      var first = Math.max(1, Math.min(count - 1, o.from | 0 || 1));
      var last = Math.max(first + 1, Math.min(count, o.to | 0 || count));
      for (var n = first; n <= last; n += step) frames.push(n);
      if (frames[frames.length - 1] !== last) frames.push(last);
    }
    this.frames = frames;
    this.n = frames.length;
    this.imgs = new Array(this.n);
    this.state = new Uint8Array(this.n); // 0 idle, 1 loading, 2 ready, 3 failed
    this.queue = this.order();
    this.active = 0;
    this.ready = 0;
    this.failed = 0;
    this.started = false;
    this.dead = false;
  }
  FrameSequence.prototype.kind = 'sequence';
  FrameSequence.prototype.url = function (i) {
    return this.tpl.base + pad3(this.frames[i]) + this.tpl.ext + '?width=' + this.width;
  };
  FrameSequence.prototype.order = function () {
    var n = this.n, seen = new Uint8Array(n), out = [];
    var add = function (i) { if (i >= 0 && i < n && !seen[i]) { seen[i] = 1; out.push(i); } };
    add(0); add(n - 1);
    for (var s = 32; s >= 1; s >>= 1) for (var i = 0; i < n; i += s) add(i);
    return out;
  };
  FrameSequence.prototype.start = function () {
    if (this.started || this.dead) return;
    this.started = true;
    this.pump();
  };
  FrameSequence.prototype.pump = function () {
    while (this.active < this.max && this.queue.length) {
      var i = this.queue.shift();
      if (!this.state[i]) this.fetch(i);
    }
  };
  FrameSequence.prototype.fetch = function (i) {
    if (this.state[i] || this.dead) return;
    var self = this, img = new Image();
    this.state[i] = 1;
    this.active++;
    img.decoding = 'async';
    this.imgs[i] = img;
    var finished = false;
    var done = function (ok) {
      if (finished || self.dead) return;
      finished = true;
      self.active--;
      self.state[i] = ok ? 2 : 3;
      if (ok) self.ready++; else self.failed++;
      if (ok && self.onLoad) self.onLoad(self, i);
      if (self.started) self.pump();
    };
    img.onload = function () {
      if (img.decode) img.decode().then(function () { done(true); }, function () { done(true); });
      else done(true);
    };
    img.onerror = function () { done(false); };
    img.src = this.url(i);
  };
  FrameSequence.prototype.pick = function (pos) {
    var n = this.n;
    pos = clamp(pos, 0, n - 1);
    var i0 = Math.floor(pos), i1 = Math.min(n - 1, i0 + 1), t = pos - i0;
    if (this.state[i0] === 2 && this.state[i1] === 2) {
      return { a: this.imgs[i0], b: i1 !== i0 && t > 0.001 ? this.imgs[i1] : null, t: t, key: i0 + ':' + t.toFixed(3) };
    }
    var r = Math.round(pos);
    for (var d = 0; d < n; d++) {
      if (r - d >= 0 && this.state[r - d] === 2) return { a: this.imgs[r - d], b: null, t: 0, key: String(r - d) };
      if (r + d < n && this.state[r + d] === 2) return { a: this.imgs[r + d], b: null, t: 0, key: String(r + d) };
    }
    return null;
  };
  FrameSequence.prototype.at = function (p) { return this.pick(clamp(p) * (this.n - 1)); };
  FrameSequence.prototype.status = function () { return this.ready + '/' + this.n + ' frames'; };
  FrameSequence.prototype.destroy = function () {
    this.dead = true;
    for (var i = 0; i < this.n; i++) {
      var img = this.imgs[i];
      if (img) { img.onload = img.onerror = null; if (this.state[i] === 1) img.src = ''; }
    }
    this.imgs = [];
  };

  /* ----------------------------------------------------------- VideoScrubber
     Uses the uploaded Shopify video directly. The file is downloaded once into
     memory (so seeks are local), and seeks are throttled: a new seek is only
     issued after the previous one has finished, always to the LATEST scroll
     position. This avoids the queue of pending seeks that makes naive
     currentTime scrubbing stutter. */
  function VideoScrubber(o) {
    this.sources = o.sources;
    this.preferH = o.preferH;
    this.onLoad = o.onLoad;
    this.mount = o.mount;
    this.from = o.from || 0;
    this.to = o.to == null ? 1 : o.to;
    this.ready = false;
    this.seeking = false;
    this.target = 0;
    this.started = false;
    this.dead = false;
    this.n = 2;
  }
  VideoScrubber.prototype.kind = 'video';
  VideoScrubber.prototype.start = function () {
    if (this.started || this.dead) return;
    this.started = true;
    var self = this, url = pickSource(this.sources, this.preferH);
    if (!url) return;
    var v = document.createElement('video');
    v.muted = true; v.defaultMuted = true; v.playsInline = true; v.preload = 'auto';
    v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('aria-hidden', 'true');
    v.className = 'kc-scrub-video';
    this.mount.appendChild(v);
    this.v = v;

    var attach = function (src) {
      if (self.dead) return;
      v.addEventListener('loadeddata', function () {
        // iOS only paints decoded frames after a play() - prime it, then pause.
        var p = v.play();
        var after = function () { v.pause(); self.ready = true; self.seek(true); };
        if (p && p.then) p.then(after, after); else after();
      }, { once: true });
      v.addEventListener('seeked', function () {
        self.seeking = false;
        if (self.onLoad) self.onLoad(self);
        self.seek();
      });
      v.src = src;
      v.load();
    };

    if (window.fetch && window.URL && URL.createObjectURL) {
      fetch(url, { mode: 'cors', credentials: 'omit' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.blob(); })
        .then(function (b) { if (self.dead) return; self.blobUrl = URL.createObjectURL(b); attach(self.blobUrl); })
        .catch(function () { attach(url); });
    } else attach(url);
  };
  VideoScrubber.prototype.set = function (p) {
    this.target = this.from + clamp(p) * (this.to - this.from);
    this.seek();
  };
  VideoScrubber.prototype.seek = function (force) {
    var v = this.v;
    if (!v || !this.ready || this.seeking) return;
    var dur = v.duration;
    if (!dur || !isFinite(dur)) return;
    var t = this.target * Math.max(0, dur - 0.05);
    if (!force && Math.abs(v.currentTime - t) < 0.012) return;
    this.seeking = true;
    v.currentTime = t;
  };
  VideoScrubber.prototype.at = function (p) {
    this.set(p);
    if (!this.ready || !this.v || this.v.readyState < 2) return null;
    return { a: this.v, b: null, t: 0, key: 'v' + this.v.currentTime.toFixed(3) };
  };
  VideoScrubber.prototype.status = function () { return this.ready ? 'video ready' : this.started ? 'video loading' : 'video waiting'; };
  VideoScrubber.prototype.destroy = function () {
    this.dead = true;
    if (this.v) { try { this.v.pause(); this.v.removeAttribute('src'); this.v.load(); } catch (e) {} this.v.remove(); }
    if (this.blobUrl) URL.revokeObjectURL(this.blobUrl);
  };

  /* --------------------------------------------------------------- Cinematic */
  function Cinematic(root) {
    var self = this;
    this.root = root;
    this.wrapper = root.closest('.shopify-section') || root;
    try { this.cfg = JSON.parse(root.querySelector('[data-kc-config]').textContent); }
    catch (e) { this.cfg = {}; console.warn('[Katt Cosmic] Could not read settings', e); }
    var c = this.cfg;

    this.stage = root.querySelector('[data-kc-stage]');
    if (!this.stage) return;
    this.media = this.stage.querySelector('.kc-media');
    this.canvas = this.stage.querySelector('.kc-canvas');
    this.ctx = this.canvas.getContext('2d', { alpha: true });
    this.loopG = this.stage.querySelector('.kc-loop--galaxy');
    this.loopS = this.stage.querySelector('.kc-loop--smoke');

    // Move the stage to <body> so no section wrapper (transforms, overflow,
    // stacking contexts) can break the fixed, full-screen background.
    document.body.insertBefore(this.stage, document.body.firstChild);
    var html = document.documentElement;
    html.classList.add('kc-active');
    html.classList.add(c.panels === 'keep' ? 'kc-panels-keep' : 'kc-panels-transparent');

    this.main = document.getElementById('MainContent') || this.wrapper.closest('main') || this.wrapper.parentElement;
    this.d = [0, 0, 0];           // displayed progress: T1, T2, End fade
    this.first = true;
    this.lastKey = '';
    this.loadReady = false;

    this.decideMode();
    this.buildSources();
    this.applyStageClasses();
    this.resizeCanvas();
    this.layout();

    // Events
    this.onScroll = function () { self.requestTick(); };
    this.onResize = function () { self.handleResize(); };
    this.onVis = function () { if (document.hidden) self.pauseLoops(); else self.requestTick(); };
    this.onLoadEvt = function () { self.scheduleLayout(); self.beginLoading(); };
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize, { passive: true });
    window.addEventListener('orientationchange', this.onResize, { passive: true });
    document.addEventListener('visibilitychange', this.onVis);
    if (document.readyState === 'complete') this.beginLoading();
    else window.addEventListener('load', this.onLoadEvt, { once: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { self.scheduleLayout(); });
    if (window.ResizeObserver && this.main) {
      this.ro = new ResizeObserver(function () { self.scheduleLayout(); });
      this.ro.observe(this.main);
    }
    if (window.matchMedia) {
      this.rmq = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onRmq = function () { KC.restart(); };
      if (this.rmq.addEventListener) this.rmq.addEventListener('change', this.onRmq);
    }
    if (c.debug && c.designMode) this.buildHud();

    // First frame: load it immediately so the canvas is ready at the top.
    [this.t1, this.t2].forEach(function (src) { if (src && src.kind === 'sequence') src.fetch(0); });
    if (this.mode === 'scrub' && this.loopG && this.galaxyLoopSrc) this.loadLoop(this.loopG, this.galaxyLoopSrc, true);

    this.requestTick();
  }

  Cinematic.prototype.decideMode = function () {
    var c = this.cfg;
    this.reduced = mq('(prefers-reduced-motion: reduce)');
    this.mobile = mq('(max-width: 749px)') || (mq('(pointer: coarse)') && Math.min(screen.width, screen.height) < 820);
    this.portrait = window.innerHeight > window.innerWidth;
    var saveData = navigator.connection && navigator.connection.saveData;
    var mode = 'scrub';
    if (!c.enabled) mode = 'off';
    else if (this.reduced) mode = c.reducedMotion === 'image' ? 'off' : 'stills';
    else if (saveData) mode = 'stills';
    else if (this.mobile && c.mobileMode === 'static') mode = 'stills';
    this.mode = mode;
    this.lite = this.mobile && c.mobileMode !== 'full';
    this.focusX = (this.mobile ? c.focusXMobile : c.focusX);
    this.focusX = (this.focusX == null ? 50 : this.focusX) / 100;
    this.canvasDpr = this.lite ? 1 : Math.min(window.devicePixelRatio || 1, 1.5);
    this.galaxyLoopSrc = pickSource(c.galaxyLoop, this.mobile ? 720 : 1080);
    this.smokeLoopSrc = pickSource(c.smokeLoop, this.mobile ? 720 : 1080);
  };

  Cinematic.prototype.frameWidth = function (aspect) {
    var c = this.cfg;
    var dpr = this.lite ? 1 : Math.min(window.devicePixelRatio || 1, 1.5);
    var vh = this.stage.clientHeight || window.innerHeight;
    var need = Math.max(window.innerWidth, vh * aspect) * dpr;
    var max = this.mobile ? (+c.mobileMaxWidth || 1280) : (+c.maxWidth || 1600);
    for (var i = 0; i < WIDTHS.length; i++) if (WIDTHS[i] >= need && WIDTHS[i] <= max) return WIDTHS[i];
    return max;
  };

  Cinematic.prototype.buildSources = function () {
    var self = this, c = this.cfg;
    var onLoad = function () { self.requestTick(); };
    // Optional "Start at frame" / "End at frame": play only part of the clip.
    var range = function (spec) {
      var count = Math.max(2, spec.count | 0 || 120);
      var a = Math.max(1, Math.min(count - 1, spec.from | 0 || 1));
      var b = Math.max(a + 1, Math.min(count, spec.to | 0 || count));
      return { count: count, a: a, b: b, fa: (a - 1) / (count - 1), fb: (b - 1) / (count - 1) };
    };
    var make = function (spec) {
      if (!spec || self.mode === 'off') return null;
      var r = range(spec);
      var useMobile = self.mobile && self.portrait && spec.tplMobile;
      var tpl = parseTemplate(useMobile ? spec.tplMobile : spec.tpl);
      var hasVideo = spec.video && spec.video.length;
      var wantVideo = spec.source === 'video' || (spec.source === 'auto' && !tpl);
      if (self.mode === 'stills') {
        if (!tpl) return null; // stills need image frames; otherwise the poster/fallback image is used
        return new FrameSequence({ tpl: tpl, only: [r.a, r.b], width: self.frameWidth(useMobile ? 9 / 16 : 16 / 9), onLoad: onLoad, concurrency: 3 });
      }
      if (wantVideo && hasVideo) {
        return new VideoScrubber({ sources: spec.video, preferH: self.lite ? 720 : 1080, onLoad: onLoad, mount: self.stage, from: r.fa, to: r.fb });
      }
      if (tpl) {
        return new FrameSequence({
          tpl: tpl,
          count: r.count,
          from: r.a,
          to: r.b,
          step: self.lite ? (+c.mobileStep || 2) : 1,
          width: self.frameWidth(useMobile ? 9 / 16 : 16 / 9),
          onLoad: onLoad,
          concurrency: self.mobile ? 4 : 6
        });
      }
      if (hasVideo) return new VideoScrubber({ sources: spec.video, preferH: self.lite ? 720 : 1080, onLoad: onLoad, mount: self.stage, from: r.fa, to: r.fb });
      return null;
    };
    this.t1 = make(c.t1);
    this.t2 = make(c.t2);
    this.builtPortrait = this.portrait;
  };

  Cinematic.prototype.applyStageClasses = function () {
    var c = this.cfg;
    var ambient = this.mode !== 'off' && !this.reduced && (this.mobile ? c.ambientMobile : c.ambient);
    this.stage.classList.toggle('kc-ambient', !!ambient);
    this.stage.classList.toggle('kc-mode-' + this.mode, true);
  };

  Cinematic.prototype.beginLoading = function () {
    var self = this;
    if (this.loadReady) return;
    idle(function () {
      self.loadReady = true;
      if (self.mode === 'stills') { if (self.t1) self.t1.start(); if (self.t2) self.t2.start(); }
      else if (self.t1) self.t1.start();
      self.requestTick();
    });
  };

  /* -------- Timeline: where each transformation happens, from section positions */
  Cinematic.prototype.scheduleLayout = function () {
    var self = this;
    clearTimeout(this.layoutTimer);
    this.layoutTimer = setTimeout(function () { self.layout(); self.requestTick(); }, 120);
  };

  Cinematic.prototype.layout = function () {
    var c = this.cfg, fb = c.fallback || {};
    var vh = window.innerHeight;
    this.vh = vh;
    var docH = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight);
    var maxY = Math.max(1, docH - vh);
    this.maxY = maxY;
    var sens = (+c.sensitivity || 100) / 100;
    var scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var cues = Array.prototype.slice.call(document.querySelectorAll('[data-kc-cue]'));
    var find = function (type) { for (var i = 0; i < cues.length; i++) if (cues[i].getAttribute('data-kc-cue') === type) return cues[i]; return null; };

    var fromCue = function (el) {
      var y = el.getBoundingClientRect().top + scrollY;
      var startAt = parseFloat(el.getAttribute('data-kc-start'));
      var length = parseFloat(el.getAttribute('data-kc-length'));
      if (isNaN(startAt)) startAt = 100;
      if (isNaN(length)) length = 80;
      var start = y - vh * (startAt / 100);
      return { start: start, end: start + Math.max(20, vh * (length / 100) / sens), from: 'cue' };
    };
    var fromPage = function (s, e) { return { start: maxY * s / 100, end: maxY * Math.max(e, s + 1) / 100, from: 'page %' }; };
    var num = function (v, d) { v = parseFloat(v); return isNaN(v) ? d : v; };

    var g = find('geode'), s = find('smoke'), e = find('end');
    // An 'End' cue on its own doesn't switch off the page-% timing.
    var anyCue = !!(g || s);
    var T1 = g ? fromCue(g) : (anyCue ? null : fromPage(num(fb.t1s, 15), num(fb.t1e, 35)));
    var T2 = s ? fromCue(s) : (anyCue || !(this.t2 || this.smokeLoopSrc) ? null : fromPage(num(fb.t2s, 55), num(fb.t2e, 75)));
    var T3 = e ? fromCue(e) : null;

    // A transformation must be able to finish before the bottom of the page.
    var fit = function (T) {
      if (!T) return T;
      // Never start "part-way through" at the top of the page: on tall screens a
      // cue near the top would otherwise give a negative start. Frame 1 always
      // shows at scroll position 0; the finish point stays where the cue says.
      if (T.start < 0) {
        T.start = 0;
        T.end = Math.max(T.end, Math.min(maxY, vh * 0.4));
        T.clamped = true;
      }
      if (T.end > maxY) {
        var len = T.end - T.start;
        T.end = maxY;
        if (T.start > T.end - Math.min(len, vh * 0.5)) T.start = Math.max(0, T.end - Math.min(len, vh * 0.5));
        T.squeezed = true;
      }
      return T;
    };
    T1 = fit(T1); T2 = fit(T2); T3 = fit(T3);
    // Keep the order Galaxy\u2192Geode, then Geode\u2192Smoke, then End, without overlap.
    if (T1 && T2 && T2.start < T1.end) { var l2 = T2.end - T2.start; T2.start = T1.end; T2.end = T2.start + l2; T2 = fit(T2); }
    var prev = T2 || T1;
    if (prev && T3 && T3.start < prev.end) { var l3 = T3.end - T3.start; T3.start = prev.end; T3.end = T3.start + l3; T3 = fit(T3); }
    this.T = [T1, T2, T3];

    // See-through sections: every section on this page up to an "End" cue.
    var sections = this.main ? Array.prototype.slice.call(this.main.children).filter(function (el) { return el.classList && el.classList.contains('shopify-section'); }) : [];
    var on = c.transparent !== false && this.mode !== undefined;
    sections.forEach(function (sec) {
      var after = e && !sec.contains(e) && (e.compareDocumentPosition(sec) & Node.DOCUMENT_POSITION_FOLLOWING);
      sec.classList.toggle('kc-section', !!(on && !after));
    });
    this.sections = sections;
  };

  Cinematic.prototype.handleResize = function () {
    var w = window.innerWidth, h = window.innerHeight;
    var widthChanged = w !== this.lastW;
    // Ignore mobile browser-bar show/hide (height-only, small) to avoid jumps.
    if (!widthChanged && this.mobile && Math.abs(h - (this.lastH || h)) < 140) return;
    this.lastW = w; this.lastH = h;
    var portrait = h > w;
    if (portrait !== this.builtPortrait && ((this.cfg.t1 && this.cfg.t1.tplMobile) || (this.cfg.t2 && this.cfg.t2.tplMobile))) {
      this.portrait = portrait;
      if (this.t1) this.t1.destroy();
      if (this.t2) this.t2.destroy();
      this.buildSources();
      if (this.loadReady && this.t1) this.t1.start();
    }
    this.resizeCanvas();
    this.scheduleLayout();
  };

  Cinematic.prototype.resizeCanvas = function () {
    var w = Math.max(1, Math.round(this.media.clientWidth * this.canvasDpr));
    var h = Math.max(1, Math.round(this.media.clientHeight * this.canvasDpr));
    if (this.canvas.width !== w || this.canvas.height !== h) {
      this.canvas.width = w;
      this.canvas.height = h;
      this.lastKey = '';
    }
    if (!this.lastW) { this.lastW = window.innerWidth; this.lastH = window.innerHeight; }
  };

  /* ------------------------------------------------------------- Main loop */
  Cinematic.prototype.requestTick = function () {
    var self = this;
    if (this.dead || this.raf) return;
    this.raf = requestAnimationFrame(function (t) { self.tick(t); });
  };

  Cinematic.prototype.tick = function (now) {
    this.raf = 0;
    if (this.dead) return;
    var c = this.cfg;
    var dt = this.lastT ? Math.min(100, now - this.lastT) : 16.7;
    this.lastT = now;
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    var T = this.T || [];
    var prog = function (t) { return t ? clamp((y - t.start) / ((t.end - t.start) || 1)) : 0; };
    var goal = [prog(T[0]), prog(T[1]), prog(T[2])];
    this.goal = goal;
    var moving = false;
    var scrollControl = c.scrollControl !== false;
    var k = clamp((+c.smoothing || 0) / 100, 0, 0.95);
    var alpha = 1 - Math.pow(k, dt / 16.667);
    var rate = dt / (Math.max(0.3, +c.autoDuration || 2.5) * 1000);

    for (var i = 0; i < 3; i++) {
      var g = goal[i], cur = this.d[i], next;
      if (!scrollControl && i < 2) {
        // Triggered mode: each transformation plays (or rewinds) on its own.
        var target = g >= 0.5 ? 1 : 0;
        next = cur < target ? Math.min(target, cur + rate) : Math.max(target, cur - rate);
        if (this.first) next = target;
      } else if (this.first || k === 0) {
        next = g;
      } else {
        // Glide toward the exact scroll position, then stop ON it.
        next = cur + (g - cur) * alpha;
        if (Math.abs(g - next) < 0.0008) next = g;
      }
      if (next !== (scrollControl || i === 2 ? g : (g >= 0.5 ? 1 : 0))) moving = true;
      this.d[i] = next;
    }
    this.first = false;

    this.maybeLoad(y);
    this.render();
    this.updateLoops();
    this.updateFade();
    if (this.hud) this.updateHud(y);

    if (moving) this.requestTick();
    else this.lastT = 0;
  };

  Cinematic.prototype.maybeLoad = function (y) {
    var T = this.T || [];
    var vh = this.vh || window.innerHeight;
    // Galaxy\u2192Geode frames: after page load (idle), or immediately once the visitor scrolls into it.
    if (this.t1 && !this.t1.started && (this.loadReady || this.d[0] > 0)) this.t1.start();
    // Geode\u2192Smoke frames: only when the visitor approaches that part of the page.
    var near2 = (T[1] && y > T[1].start - vh * 1.5) || this.d[0] > 0.25 || (!this.t1 && this.loadReady);
    if (near2) {
      if (this.t2 && !this.t2.started) this.t2.start();
      if (this.mode === 'scrub' && this.loopS && this.smokeLoopSrc && !this.loopS.getAttribute('src')) this.loadLoop(this.loopS, this.smokeLoopSrc, false);
    }
  };

  /* --------------------------------------------------------------- Drawing */
  Cinematic.prototype.drawCover = function (src, a) {
    var ctx = this.ctx, cw = this.canvas.width, ch = this.canvas.height;
    var iw = src.naturalWidth || src.videoWidth, ih = src.naturalHeight || src.videoHeight;
    if (!iw || !ih) return false;
    var s = Math.max(cw / iw, ch / ih);
    var sw = cw / s, sh = ch / s;
    var sx = (iw - sw) * this.focusX, sy = (ih - sh) * 0.5;
    ctx.globalAlpha = a;
    try { ctx.drawImage(src, sx, sy, sw, sh, 0, 0, cw, ch); } catch (e) { return false; }
    return true;
  };

  Cinematic.prototype.render = function () {
    var layers = [], d = this.d, t1 = this.t1, t2 = this.t2, blend = this.cfg.frameBlend !== false;
    var push = function (pick, a) {
      if (!pick || a <= 0.001) return;
      layers.push({ img: pick.a, a: a, key: pick.key });
      if (blend && pick.b && pick.t > 0.01) layers.push({ img: pick.b, a: a * pick.t, key: pick.key + 'b' });
    };

    if (this.mode === 'off') return;

    if (this.mode === 'stills') {
      // Reduced motion / save-data: three stills that dissolve with scroll position.
      var A = t1 && t1.pick(0), B = t1 && t1.pick(t1.n - 1), C = t2 && t2.pick(t2.n - 1);
      if (A) layers.push({ img: A.a, a: 1, key: 'A' });
      if (B) layers.push({ img: B.a, a: A ? d[0] : 1, key: 'B' + d[0].toFixed(3) });
      if (C) layers.push({ img: C.a, a: d[1], key: 'C' + d[1].toFixed(3) });
    } else {
      var p1 = t1 ? t1.at(d[0]) : null;
      var useT2 = t2 && d[1] > 0;
      var p2 = useT2 ? t2.at(d[1]) : null;
      if (p2) {
        // Seam guard: during the first 3% of Geode\u2192Smoke, the final geode frame
        // of video 1 dissolves into the first frame of video 2, hiding any tiny
        // difference between the two Kling clips.
        var seam = clamp(d[1] / 0.03);
        if (seam < 1 && t1) {
          push(t1.at(1), 1);
          push(p2, seam);
        } else push(p2, 1);
      } else {
        // Not started yet (or video 2 still loading): hold the geode / galaxy frame.
        push(t1 ? (useT2 ? t1.at(1) : p1) : null, 1);
      }
    }

    if (!layers.length) return;
    var key = this.canvas.width + 'x' + this.canvas.height + '|' + layers.map(function (l) { return l.key + '@' + l.a.toFixed(3); }).join('|');
    if (key === this.lastKey) return;
    this.lastKey = key;

    var drew = false;
    for (var i = 0; i < layers.length; i++) {
      if (this.drawCover(layers[i].img, i === 0 ? 1 : layers[i].a)) drew = true;
    }
    this.ctx.globalAlpha = 1;
    if (drew && !this.canvasReady) {
      this.canvasReady = true;
      this.canvas.classList.add('is-ready');
    }
  };

  /* --------------------------------------------------------- Ambient loops */
  Cinematic.prototype.loadLoop = function (el, src, eager) {
    if (!el || !src || el.getAttribute('src')) return;
    var self = this;
    el.muted = true; el.defaultMuted = true; el.playsInline = true;
    el.preload = eager ? 'auto' : 'metadata';
    el.addEventListener('canplay', function () { if (el._kcWant) self.playLoop(el); });
    el.src = src;
  };
  Cinematic.prototype.playLoop = function (el) {
    var p = el.play();
    if (p && p.catch) p.catch(function () {});
  };
  Cinematic.prototype.setLoop = function (el, src, opacity) {
    if (!el || !src) return;
    var on = opacity > 0.002 && !document.hidden;
    if (on && !el.getAttribute('src')) this.loadLoop(el, src, true);
    if (el._kcOp !== opacity) { el.style.opacity = opacity.toFixed(3); el._kcOp = opacity; }
    el._kcWant = on;
    if (on && el.paused && el.readyState >= 2) this.playLoop(el);
    else if (!on && !el.paused) el.pause();
  };
  Cinematic.prototype.updateLoops = function () {
    if (this.mode !== 'scrub') { this.pauseLoops(); return; }
    var cf = clamp((+this.cfg.loopCrossfade || 15) / 100, 0.02, 0.5);
    var gOp = 1 - smoothstep(0, this.t1 ? cf : 1, this.d[0]);
    var sOp = smoothstep(this.t2 ? 1 - cf : 0, 1, this.d[1]);
    this.setLoop(this.loopG, this.galaxyLoopSrc, gOp);
    this.setLoop(this.loopS, this.smokeLoopSrc, sOp);
  };
  Cinematic.prototype.pauseLoops = function () {
    [this.loopG, this.loopS].forEach(function (el) { if (el && !el.paused) el.pause(); });
  };
  Cinematic.prototype.updateFade = function () {
    var f = this.d[2] || 0;
    if (f !== this.lastFade) { this.stage.style.setProperty('--kc-fade', f.toFixed(3)); this.lastFade = f; }
  };

  /* ------------------------------------------------- Theme-editor timing HUD */
  Cinematic.prototype.buildHud = function () {
    this.hud = document.createElement('div');
    this.hud.className = 'kc-hud';
    document.body.appendChild(this.hud);
  };
  Cinematic.prototype.updateHud = function (y) {
    var T = this.T || [], d = this.d, self = this;
    var bar = function (v) { return '<span class="kc-bar"><i style="width:' + Math.round(v * 100) + '%"></i></span>'; };
    var row = function (name, t, v, src) {
      if (!t) return name + '  <i>no cue - add a scene cue</i>';
      return name + ' ' + String(Math.round(v * 100)).padStart(3, ' ') + '%' + bar(v) +
        '\n   scroll ' + Math.round(t.start) + ' to ' + Math.round(t.end) + 'px (' + t.from + (t.squeezed ? ', shortened to fit page' : '') + ')' +
        (src ? '\n   ' + src.status() : '');
    };
    var state = d[1] >= 1 ? 'SMOKE' : d[1] > 0 ? 'Geode \u2192 Smoke' : d[0] >= 1 ? 'GEODE' : d[0] > 0 ? 'Galaxy \u2192 Geode' : 'GALAXY';
    this.hud.innerHTML =
      '<b>Katt Cosmic timing guide</b> (editor only)\n' +
      'now: <b>' + state + '</b>   scroll ' + Math.round(y) + ' / ' + Math.round(this.maxY || 0) + 'px\n' +
      row('Galaxy\u2192Geode', T[0], d[0], self.t1) + (T[1] || self.t2 ? '\n' : '') +
      (T[1] || self.t2 ? row('Geode\u2192Smoke ', T[1], d[1], self.t2) : '') +
      (T[2] ? '\n' + row('End fade    ', T[2], d[2]) : '') +
      '\nmode: ' + this.mode + (this.lite ? ' (lighter phone mode)' : '') + (this.cfg.scrollControl === false ? ', triggered playback' : ', scroll-controlled');
  };

  /* --------------------------------------------------------------- Cleanup */
  Cinematic.prototype.destroy = function () {
    this.dead = true;
    if (this.raf) cancelAnimationFrame(this.raf);
    clearTimeout(this.layoutTimer);
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
    window.removeEventListener('orientationchange', this.onResize);
    window.removeEventListener('load', this.onLoadEvt);
    document.removeEventListener('visibilitychange', this.onVis);
    if (this.rmq && this.rmq.removeEventListener) this.rmq.removeEventListener('change', this.onRmq);
    if (this.ro) this.ro.disconnect();
    if (this.t1) this.t1.destroy();
    if (this.t2) this.t2.destroy();
    this.pauseLoops();
    if (this.stage) this.stage.remove();
    if (this.hud) this.hud.remove();
    (this.sections || []).forEach(function (s) { s.classList.remove('kc-section'); });
    var html = document.documentElement;
    html.classList.remove('kc-active', 'kc-panels-keep', 'kc-panels-transparent');
  };

  /* -------------------------------------------------------- Bootstrapping */
  var KC = {
    instance: null,
    init: function () {
      var roots = document.querySelectorAll('[data-kc-root]');
      var root = roots[0];
      if (roots.length > 1) console.warn('[Katt Cosmic] More than one background section on this page - only the first is used.');
      if (KC.instance && KC.instance.root === root && !KC.instance.dead) return;
      if (KC.instance) { KC.instance.destroy(); KC.instance = null; }
      if (root) KC.instance = new Cinematic(root);
    },
    restart: function () {
      if (KC.instance) { KC.instance.destroy(); KC.instance = null; }
      KC.init();
    },
    relayout: function () {
      if (KC.instance) setTimeout(function () { if (KC.instance) { KC.instance.layout(); KC.instance.requestTick(); } }, 80);
    }
  };
  window.KattCosmic = KC;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', KC.init);
  else KC.init();

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target;
    if (t && t.querySelector && t.querySelector('[data-kc-root]')) KC.restart();
    else { if (!KC.instance) KC.init(); KC.relayout(); }
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var t = e.target;
    if (KC.instance && t && t.contains && t.contains(KC.instance.root)) {
      KC.instance.destroy();
      KC.instance = null;
    } else KC.relayout();
  });
  document.addEventListener('shopify:section:reorder', KC.relayout);
  document.addEventListener('shopify:section:select', KC.relayout);
})();
